import { createAction } from '@reduxjs/toolkit';

import type { ProcessFlow, ProcessFlowStep } from '~/common/model/api/batch-type/process-flow';

import type { SettingsBatchTypeLibrarySlice, SettingsBatchTypeLibrarySliceActionType } from '../_slice.type';

const processFlowAction = (slice: SettingsBatchTypeLibrarySlice) => {
  const actionType = (type: SettingsBatchTypeLibrarySliceActionType) => `${slice.reducerPath}/${type}` as const;

  return {
    processFlow_setData: createAction(actionType('processFlow_setData'), (payload: ProcessFlow | undefined) => ({
      payload: payload ? JSON.stringify(payload) : undefined,
    })),

    processFlow_setRawInitialSteps: createAction(actionType('processFlow_setRawInitialSteps'), (payload: ProcessFlowStep[] | undefined) => ({
      payload: payload ? JSON.stringify(payload) : undefined,
    })),
  };
};

export { processFlowAction };
